import img1 from "../images/icon/icon1.png";
import img2 from "../images/icon/icon2.png";
import img3 from "../images/icon/icon3.png";
import img4 from "../images/icon/icon4.png";

const dataBox = [
  {
    id: 1,
    img: img1,
    title: "Full-Stack Development",
    desc: "I offer comprehensive web solutions including custom CMS, e-commerce platforms, progressive web apps",
  },
  {
    id: 2,
    img: img2,
    title: "Application Development",
    desc: "I offer comprehensive app solutions including native development, cross-platform apps",
  },
  {
    id: 3,
    img: img3,
    title: "Web Application Design",
    desc: "I offer comprehensive design solutions including responsive layouts, modern animations, and user-centric experiences",
  },
  {
    id: 4,
    img: img4,
    title: "Graphic Design & Branding",
    desc: "I offer comprehensive design solutions including brand identity, social media design, and creative visual content for all platforms",
  },
];

export default dataBox;
